import React, { useContext } from "react";
import { Dropdown, Typography } from "antd";
import "./CustomLayout.css";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../../../context/UserContext";
import UserSettingsAvatar from "./UserSettingsAvatar";
import { USER_SETTINGS_MENU_ITEMS } from "./userSettingsMenu";

const UserSettings = () => {
  const { userDetails } = useContext(UserContext);
  const navigate = useNavigate();

  const items = USER_SETTINGS_MENU_ITEMS.map((item) => ({
    key: item.key,
    label: (
      <div
        style={{ gap: "12px" }}
        className="flex-start"
        onClick={() => navigate(item.href)}
      >
        <item.Icon />
        {item.title}
      </div>
    ),
  }));

  return (
    <div style={{ marginLeft: "20px", marginRIght: "20px" }}>
      <Dropdown
        menu={{
          items,
        }}
        dropdownRender={(menu) => (
          <div className={"profileMenu"} style={{ marginTop: "8px" }}>
            <div
              className="text-left"
              style={{
                padding: "16px",
                gap: "16px",
                borderBottom: "1px solid #EAECF0",
              }}
            >
              <Typography style={{ fontWeight: 600, textAlign: "left" }}>
                {userDetails?.first_name} {userDetails?.last_name}
                <br />
                <span style={{ color: "#475467", fontWeight: 400 }}>
                  {userDetails?.email}
                </span>
              </Typography>
            </div>

            {React.cloneElement(menu, {
              className: "settingsdropDown",
              style: {
                boxShadow: "none",
                padding: "6px",
              },
            })}
          </div>
        )}
        className={"profileDropDown"}
        placement="bottomRight"
      >
        <span style={{ cursor: "pointer", display: "inline-flex" }}>
          <UserSettingsAvatar size={40} />
        </span>
      </Dropdown>
    </div>
  );
};

export default UserSettings;
